(() => {
  if (window.VistoSwiper) return

  const instances = new WeakMap()

  const getSwiperNodes = (root = document) => {
    const nodes = []

    if (root instanceof HTMLElement && root.matches('[data-visto-swiper]')) {
      nodes.push(root)
    }

    if ('querySelectorAll' in root) {
      nodes.push(...root.querySelectorAll('[data-visto-swiper]'))
    }

    return nodes
  }

  const parseOptions = (node) => {
    const source = node.querySelector('[data-visto-swiper-options]')
    const raw = source?.textContent || node.dataset.vistoSwiperOptions || '{}'

    try {
      return JSON.parse(raw)
    } catch (error) {
      console.warn('[VistoSwiper] Invalid Swiper options.', error)
      return {}
    }
  }

  const getNavigation = (node) => {
    const nextEl = node.querySelector('[data-visto-swiper-next]')
    const prevEl = node.querySelector('[data-visto-swiper-prev]')

    if (!nextEl && !prevEl) return false
    return { nextEl, prevEl }
  }

  const getScrollbar = (node) => {
    const el = node.querySelector('[data-visto-swiper-scrollbar]')

    if (!el) return false
    return {
      el,
      draggable: true,
    }
  }

  const applyBaseStructure = (node) => {
    const wrapper = node.querySelector('.visto-swiper__track, [data-visto-swiper-track]')
    const slides = node.querySelectorAll('.visto-swiper__slide, [data-visto-swiper-slide]')

    node.classList.add('visto-swiper')
    node.style.overflow = node.style.overflow || 'hidden'
    if (wrapper instanceof HTMLElement) {
      wrapper.classList.add('visto-swiper__track')
      wrapper.style.display = wrapper.style.display || 'flex'
      wrapper.style.width = wrapper.style.width || '100%'
    }

    slides.forEach((slide) => {
      if (slide instanceof HTMLElement) {
        slide.classList.add('visto-swiper__slide')
        slide.style.flexShrink = slide.style.flexShrink || '0'
        slide.style.width = slide.style.width || '100%'
      }
    })
  }

  const initNode = async (node) => {
    if (instances.has(node)) return instances.get(node)

    node.dataset.vistoSwiperState = 'loading'
    const Swiper = await window.VistoVendor.loadSwiper()
    const options = parseOptions(node)

    applyBaseStructure(node)

    const instance = new Swiper(node, {
      wrapperClass: node.dataset.vistoSwiperWrapperClass || 'visto-swiper__track',
      slideClass: node.dataset.vistoSwiperSlideClass || 'visto-swiper__slide',
      slidesPerView: 1,
      speed: 420,
      watchOverflow: true,
      navigation: getNavigation(node),
      scrollbar: getScrollbar(node),
      ...options,
    })

    instances.set(node, instance)
    node.dataset.vistoSwiperState = 'mounted'
    return instance
  }

  const destroyNode = (node) => {
    const instance = instances.get(node)

    if (!instance) return
    instance.destroy(true, true)
    instances.delete(node)
    delete node.dataset.vistoSwiperState
  }

  const init = (root = document) => {
    if (!window.VistoVendor) return Promise.resolve([])

    const nodes = getSwiperNodes(root)
    if (!nodes.length) return Promise.resolve([])

    return Promise.all(nodes.map((node) => initNode(node).catch((error) => {
      node.dataset.vistoSwiperState = 'error'
      console.error('[VistoSwiper] Failed to initialize Swiper.', error)
      return null
    })))
  }

  const destroy = (root = document) => {
    getSwiperNodes(root).forEach(destroyNode)
  }

  window.VistoSwiper = {
    init,
    destroy,
    initNode,
    destroyNode,
  }

  document.addEventListener('DOMContentLoaded', () => init())
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof HTMLElement) init(event.target)
  })
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target instanceof HTMLElement) destroy(event.target)
  })
})()
